// import React from "react";
import ZertoLayout from "../components/layout/ZertoLayout";
import MastheadZerto from "../components/sections/homepage/MastheadZerto";
// import Empower from "../components/sections/homepage/Empower";
// import Advantage from "../components/sections/homepage/Advantage";
// import Features from "../components/sections/homepage/Features";
// import Solution from "../components/sections/homepage/Solution";
// import CtaSection from "../components/sections/homepage/CtaSection";
// import CarouselPage from "./CarouselPage";
// import { useExperiment } from "@statsig/react-bindings";
// import ZertoOne from "./ZertoOne";
// import ZertoTwo from "./ZertoTwo";

export const OldZerto = () => {
  return (
    <ZertoLayout title="HPE Zerto Software">
      <MastheadZerto />
    </ZertoLayout>
  );
};
